"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JURISDICTIONS = void 0;
exports.jurisdictionRulesFor = jurisdictionRulesFor;
exports.thresholdsFor = thresholdsFor;
const facilityState_1 = require("../../facilityState");
const _FEDERAL_1 = require("./_FEDERAL");
const CA_1 = require("./CA");
const CT_1 = require("./CT");
const DE_1 = require("./DE");
const FL_1 = require("./FL");
const IN_1 = require("./IN");
const MA_1 = require("./MA");
const MI_1 = require("./MI");
const MN_1 = require("./MN");
const MO_1 = require("./MO");
const VT_1 = require("./VT");
/**
 * The registry of jurisdiction rules. Adding a state means one class file
 * under this directory and one entry here. A state's numbers are regulatory
 * law: verify them against that state's own regulations, never assume them
 * from another state's.
 *
 * A state missing from here gets the federal rules, so a state that just uses
 * them needs no entry.
 *
 * These are singletons instantiated at module load: the classes must carry no
 * state, only static constants and pure functions.
 */
exports.JURISDICTIONS = {
    FEDERAL: new _FEDERAL_1.FederalOnlyRules(),
    CA: new CA_1.CaliforniaRules(),
    CT: new CT_1.ConnecticutRules(),
    DE: new DE_1.DelawareRules(),
    FL: new FL_1.FloridaRules(),
    IN: new IN_1.IndianaRules(),
    MA: new MA_1.MassachusettsRules(),
    MI: new MI_1.MichiganRules(),
    MN: new MN_1.MinnesotaRules(),
    MO: new MO_1.MissouriRules(),
    VT: new VT_1.VermontRules(),
};
function isRegisteredJurisdiction(value) {
    if (!value)
        return false;
    return Object.keys(exports.JURISDICTIONS).includes(value);
}
/**
 * The class answering for a facility's state: null resolves under federal
 * law, an unseeded state or junk input falls back to federal.
 */
function jurisdictionRulesFor(state) {
    const parsed = (0, facilityState_1.parseFacilityState)(state);
    if (parsed === null || !isRegisteredJurisdiction(parsed)) {
        return exports.JURISDICTIONS.FEDERAL;
    }
    return exports.JURISDICTIONS[parsed];
}
/** The thresholds at one scope, from the rules of the facility's state. */
function thresholdsFor(situation) {
    return jurisdictionRulesFor(situation.facility.state ?? null).thresholdsFor(situation);
}
//# sourceMappingURL=index.js.map